<template>
	<div class="d-flex align-items-center">
		<div class="circular-stepper">
			<svg class="progress-ring" width="56" height="56">
				<circle
					fill="none"
					stroke-width="5"
					:stroke="'#EEE'"
					:r="radius" 
					:cx="center" 
					:cy="center" 
				/>
				<circle
					fill="none"
					stroke-width="5"
					:class="{ 'ring-progress-expired': timeExpired, 'ring-progress': !timeExpired }"
					stroke-linecap="round"
					:r="radius"
					:cx="center"
					:cy="center"
					:stroke-dasharray="circumferenceValue"
					:stroke-dashoffset="dashOffset"
				/>
			</svg>
			<div class="label" v-if="!timeExpired">{{ this.stage + 1 }} of {{ this.stages.length }}</div>
			<div class="label-icon" v-else>
				<Icon name="timeline-time-is-up-mobile" />
			</div>
		</div>
		<div class="ml16">
			<div class="d-flex align-items-center gap8">
				<div class="neue text-black">{{ getStageItem?.name }}</div>
				<Popper v-if="tooltipText" :hover="true">
					<Icon :name="'info'" size="c20" />
					<template #content>
						<div class="text-white fsp14">{{ tooltipText }}</div>
					</template>
				</Popper>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';
import Popper from '@/components/service/Popper';

export default {
	components: {
		Icon,
		Popper
	},
	props: {
		stage: [Number],
		stages: [Array],
		timeExpired: [Boolean],
		tooltipText: [String],
	},
	data() {
		return {
			radius: 25,
			center: 28,
		}
	},
	computed: {
		circumferenceValue() {
			return 2 * Math.PI * this.radius
		},
		dashOffset() {
			return this.circumferenceValue * (1 - (this.stage + 1) / this.stages.length)
		},
		getStageItem() {
			return this.stages[this.stage]
		},
		getNextStage() {
			if(this.stage !== this.stages.length) {
				return this.stages[this.stage + 1]
			}
		},
    },
}
</script>

<style lang="scss" scoped>
.circular-stepper {
  position: relative;
  width: 56px;
  height: 56px;
}

.progress-ring {
  transform: rotate(-90deg);
}

.ring-progress {
    fill: none;
    stroke-width: 5;
    stroke: $color-notification;
    transition: stroke-dashoffset 0.3s ease;
}

.ring-progress-expired {
	fill: none;
	stroke: $dark-orange;
	transition: stroke-dashoffset 0.3s ease;
}

.label-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring-progress {
  transition: stroke-dashoffset 0.3s ease;
}

.label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: 500;
  color: #000;
  text-wrap: nowrap;
}
</style>